module.exports = __webpack_public_path__ + "media/images/gallery/constellations/gemini/gem_ir-3b2d353af43d27fec26b3931dd731cb5.jpg";